import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material';
import { ReferenceDataService } from 'src/app/Services/AdminConfigurations/reference-data.service';
import { PayerTypeService } from 'src/app/Services/AdminConfigurations/payer-type.service';
import { IPayerType } from 'src/app/models/IPayerType';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-payer-type-lookup',
  templateUrl: './payer-type-lookup.component.html',
  styleUrls: ['./payer-type-lookup.component.css']
})
export class PayerTypeLookupComponent implements OnInit {
  displayedColumns: string[] = ['payerTypeCode', 'payerTypeName', 'action'];

  allPayerTypes: any[] = [];
  filteredPayerTypes: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  searchTerm: string = '';

  existingPayerTypes: IPayerType[] = [];
  private existingKeys = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<PayerTypeLookupComponent>,
    private referenceDataService: ReferenceDataService,
    private payerTypeService: PayerTypeService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loadExistingPayerTypes();
    this.loadReferencePayerTypes();
  }

  loadExistingPayerTypes() {
    this.payerTypeService.getAllPayerType().subscribe(data => {
      this.existingPayerTypes = data || [];
      this.buildExistingKeys();
      this.stampFlags();
    });
  }

  loadReferencePayerTypes() {
    this.spinner.show();
    this.referenceDataService.getPayerTypes().subscribe(
      (data) => {
        const raw = Array.isArray(data) ? data : (data as any).data || (data as any).result || [];
        this.allPayerTypes = raw.map(c => this.normalize(c));
        this.filteredPayerTypes = [...this.allPayerTypes];
        this.stampFlags();
        this.dataSource.data = this.filteredPayerTypes;
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        console.error(err);
        this.spinner.hide();
      }
    );
  }

  private normalize(c: any): any {
    return {
      sourceId: c.payerTypeId || c.PayerTypeId || c.id || c.Id,
      payerTypeCode: c.payerTypeCode || c.PayerTypeCode || c.code || c.Code,
      payerTypeName: c.payerTypeName || c.PayerTypeName || c.name || c.Name,
      isActive: c.isActive != null ? c.isActive : (c.IsActive != null ? c.IsActive : true)
    };
  }

  applySearch() {
    const term = this.searchTerm.trim().toLowerCase();
    if (term) {
      this.filteredPayerTypes = this.allPayerTypes.filter(c =>
        (c.payerTypeName && c.payerTypeName.toLowerCase().includes(term)) ||
        (c.payerTypeCode && c.payerTypeCode.toLowerCase().includes(term))
      );
    } else {
      this.filteredPayerTypes = [...this.allPayerTypes];
    }
    this.dataSource.data = this.filteredPayerTypes;
  }

  clearSearch() {
    this.searchTerm = '';
    this.applySearch();
  }

  private getKey(name: string): string {
    return (name || '').toLowerCase();
  }

  private buildExistingKeys(): void {
    this.existingKeys.clear();
    this.existingPayerTypes.forEach(e => this.existingKeys.add(this.getKey(e.payerTypeName)));
  }

  private stampFlags(): void {
    this.allPayerTypes.forEach(c => {
      c.isExisting = this.existingKeys.has(this.getKey(c.payerTypeName));
    });
  }

  addPayerType(item: any) {
    this.spinner.show();
    const payerType = new IPayerType();
    payerType.payerTypeCode = item.payerTypeCode;
    payerType.payerTypeName = item.payerTypeName;
    payerType.isActive = true;
    payerType.sourceId = item.sourceId;
    (payerType as any).facilityId = Number(sessionStorage.getItem('FacilityId'));
    (payerType as any).createdBy = encodeURIComponent(sessionStorage.getItem('userId')).toString();

    this.payerTypeService.addPayerTypeDetails(payerType).subscribe(
      (result) => {
        this.toastr.success(result);
        item.isExisting = true;
        this.existingKeys.add(this.getKey(item.payerTypeName));
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        this.toastr.error('Failed to add payer type');
        this.spinner.hide();
      }
    );
  }

  close() {
    this.dialogRef.close({ refreshRequired: true });
  }
}
